import React from 'react';
import FirewallStep1 from './Step1';
import FirewallStep2 from './Step2';
import { useQuery } from 'react-query';

const Firewall = ({ data, managerVmRefetch }) => {
  const fw_ipv4_template = data?.fw_ipv4_template || '';
  const fw_ipv4_global_template = data?.fw_ipv4_global_template || '';

  const { data: fwTemplate } = useQuery(`/vs/firewall/${fw_ipv4_template}`, {
    enabled: fw_ipv4_template != '',
  });

  const { data: globalFwTemplate } = useQuery(`/vs/firewall/${fw_ipv4_global_template}`, {
    enabled: fw_ipv4_global_template != '',
  });

  return (
    <>
      <FirewallStep1 data={data} managerVmRefetch={managerVmRefetch} />
      <FirewallStep2
        white
        data={data}
        title={'vs/instance.string240'}
        firewallTemplate={globalFwTemplate?.firewall_ruleset_rules || []}
      />
      <FirewallStep2
        data={data}
        title={'vs/instance.string241'}
        firewallTemplate={fwTemplate?.firewall_ruleset_rules || []}
      />
    </>
  );
};

export default Firewall;
